import { render } from "./ChangelogComponent.vue?vue&type=template&id=6c4bb88e&scoped=true"
import script from "./ChangelogComponent.vue?vue&type=script&lang=js"
export * from "./ChangelogComponent.vue?vue&type=script&lang=js"

import "./ChangelogComponent.vue?vue&type=style&index=0&id=6c4bb88e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4bb88e"]])

export default __exports__